// assets/whatsapp-support.js
(function () {
  // Intercept clicks on your WhatsApp link but keep a graceful fallback
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a.js-wa-memo");
    if (!link) return;

    // Build phone from existing href (so you don't duplicate it)
    let phone = "";
    try {
      const m = link.href.match(/wa\.me\/(\d+)/);
      phone = m ? m[1] : "";
    } catch (_) {}

    // Base message from existing href (?text=...)
    let base = "";
    try {
      const u = new URL(link.href, location.origin);
      base = u.searchParams.get("text") || "";
    } catch (_) {}

    // If we can't extract a phone, let the default link work
    if (!phone) return;

    // Compose the source URL
    const strip = (link.dataset.waStripParams === "true");
    let pageUrl = location.href;
    if (strip) {
      const u = new URL(location.href);
      pageUrl = u.origin + u.pathname;
    }

    const text = (base ? base.trim() + " " : "") + pageUrl;
    const wa = "https://wa.me/" + phone + "?text=" + encodeURIComponent(text);

    // Prevent the old static href and open ONLY our final URL in a new tab
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const a = document.createElement("a");
    a.href = wa;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }, true); // capture to beat other handlers
})();
